export const versementErrors = {
  400: {
    ERR_INVALID_REQUEST: "La requête est invalide.",
    ERR_INVALID_BENEFICIARY: "Le bénéficiaire est introuvable.",
    ERR_IBAN_INVALID: "Le format iban fourni est invalide",
    ERR_BIC_INVALID: "Le format bic fourni est invalide"
  },
  403: {
    ERR_FORBIDDEN: "Vous n’êtes pas autorisé à utiliser ce moyen de paiement.",
    ERR_ACCOUNT_FROZEN: "Votre compte est gelé. Impossible d’effectuer cette transaction.",
    ERR_FORBIDDEN_ALLOW_MERCHANT: "Vous n’êtes pas autorisé à effectuer cette action.",
    ERR_MERCHANT_INACTIVE: "Le compte marchand n’est pas actif.",
    ERR_MAX_BANK_ACCOUNTS: "Un marchand ne peut pas avoir plus de 3 comptes bancaires.",
  },
  404: {
    ERR_ACCOUNT_NOT_FOUND: "Compte bancaire introuvable, inactif ou n'appartenant pas au marchand.",
    ERR_MERCHANT_NOT_FOUND: "Marchand introuvable.",
  },
  408: {
    ERR_DUPLICATE_CLIENTID: "Client ID déjà utilisé.",
  },
  409: {
    ERR_INSUFFICIENT_BALANCE: "Votre solde est insuffisant pour effectuer cette opération. Vérifiez votre montant disponible.",
    ERR_IBAN_ALREADY_EXISTS: "Cet IBAN est déjà enregistré.",
  },
  410: {
    ERR_LIMIT_EXCEEDED: "Vous avez dépassé votre limite journalière de transfert.",
  },
  411: {
    ERR_DUPLICATE_TRANSFER: "Un transfert similaire a déjà été effectué dans les 5 dernières minutes.",
  },
  422: {
    ERR_COUNTRY_NOT_ELIGIBLE: "Le pays n’est pas éligible. Seuls les pays de l’UEMOA sont autorisés.",
  },
  429: {
    ERR_WEEKLY_LIMIT_EXCEEDED: "Vous avez atteint le maximum de 2 demandes de virement bancaire par semaine.",
  },
  500: {
    ERR_INTERNAL_SERVER: "Une erreur interne est survenue.",
    ERR_DATABASE: "Erreur serveur (base de données).",
  },
  502: {
    ERR_PROVIDER: "Erreur provenant du fournisseur de paiement.",
  }
};